import app from '@/app';
import templateUrl from './tree.html';
import {getTranslate} from "@/app/shared/translate-helper";

/* @ngInject */
function Controller($filter, Principal, Road) {
	var $ctrl = this;

  $ctrl.currentAccount = null;
  $ctrl.roadLabels = {};
  
  Principal.identity().then(account => {
	$ctrl.currentAccount = account;
	})

	$ctrl.$onInit = () => {
		$ctrl.prefix = $ctrl.prefix || '';
		$ctrl.decision = $ctrl.decision || 'R';
		$ctrl.path = $ctrl.prefix + $ctrl.decision;
	};

	$ctrl.getFactor = code => (code == 'KPI_TR' ? 100 : 1); // TODO: Review

	$ctrl.translate = value => {
		if (!value || _.isNumber(value)) {
			return value;
		} else {
			var splitted = value.split('_');
			var head = splitted.slice(0, 1);
			var tail = splitted.slice(1);
			var translationPath =
				'measurement.' + _.lowerCase(head) + '.' + _.camelCase(tail.join('_'));
			return $filter('translate')(translationPath);
		}
	};

  $ctrl.translatePavingType = value => {
		if (value) {
			switch (value) {
				case 1:
					return getTranslate().instant('decision_tree_node.flexible');
				case 2:
					return getTranslate().instant('decision_tree_node.semi_rigid');
				case 3:
					return getTranslate().instant('decision_tree_node.inverted_semi_rigid');
				case 4:
					return getTranslate().instant('decision_tree_node.rigid');
				case '1':
					return getTranslate().instant('decision_tree_node.flexible');
				case '2':
					return getTranslate().instant('decision_tree_node.semi_rigid');
				case '3':
					return getTranslate().instant('decision_tree_node.inverted_semi_rigid');
				case '4':
					return getTranslate().instant('decision_tree_node.rigid');
				default: return getTranslate().instant('decision_tree_node.unidentified');
			}
		}
	};

	$ctrl.getRoadLabel = id => {
		if (id && !$ctrl.roadLabels[id]) {
			$ctrl.roadLabels[id] = id;
			Road.get({ id: id }).$promise.then(res => {
				$ctrl.roadLabels[id] = res.code + ' - ' + res.name;
			});
		}
		return $ctrl.roadLabels[id] || id;
	};

	$ctrl.getDirectionLabel = value => {
		if (value) {
			switch (parseInt(value)) {
				case 1: return getTranslate().instant('direction.INC');
				case 2: return getTranslate().instant('direction.DEC');
				case 3: return getTranslate().instant('direction.BOTH');
			}
		}
		return value;
	};

	$ctrl.propagate = (model, decision) => {
		$ctrl.model[decision] = model;
		$ctrl.onChange({ model: $ctrl.model, decision: $ctrl.decision });
	};
}

app.component('prTree', {
	templateUrl,
	bindings: {
		model: '<',
		prefix: '<',
		decision: '@',
		readonly: '<',
		onChange: '&'
	},
	controller: Controller
});
